import { useEffect, useState } from "react";
import { motion } from "@/lib/motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { getHomepageClosing } from "../lib/sanityQueries";
import { peek } from "../lib/sanity";

export const CTA = ({ onBook }) => {
    const [closing, setClosing] = useState(() => peek(getHomepageClosing));
    useEffect(() => {
        let active = true;
        getHomepageClosing()
            .then((data) => {
                if (active && data) setClosing(data);
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, []);

    const cta = closing?.finalCta;

    return (
    <section
        data-testid="cta-section"
        className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36"
    >
        <div className="relative overflow-hidden rounded-card border border-brand-line bg-brand-surface px-6 py-20 text-center sm:px-16 sm:py-28">
            <div className="pointer-events-none absolute inset-0 el-grid-bg opacity-40" aria-hidden />

            <Reveal>
                <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-brand-accent">
                    Start the conversation
                </span>
            </Reveal>
            <Reveal delay={0.05}>
                <h2 className="mx-auto mt-6 max-w-3xl font-heading text-4xl font-extrabold leading-[1.0] tracking-tight text-brand-text sm:text-6xl">
                    {closing?.finalCtaHeadline ||
                        "Let's make your business secure, structured, and scalable."}
                </h2>
            </Reveal>
            <Reveal delay={0.1}>
                <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-brand-muted">
                    {closing?.finalCtaMessage ||
                        "A focused conversation about reducing risk, improving operational maturity, and helping your business grow with confidence. No jargon, no pressure."}
                </p>
            </Reveal>
            <Reveal delay={0.15}>
                {cta?.url ? (
                    <motion.a
                        whileTap={{ scale: 0.96 }}
                        href={cta.url}
                        target={cta.openInNewTab ? "_blank" : "_self"}
                        rel={cta.openInNewTab ? "noopener noreferrer" : undefined}
                        data-testid="cta-book-button"
                        className="group mt-10 inline-flex items-center gap-2 rounded-control bg-brand-accent px-9 py-4 text-base font-semibold text-brand-on-accent transition-colors duration-150"
                    >
                        {cta.label || "Schedule a Conversation"}
                        <ArrowUpRight className="h-5 w-5 transition-colors duration-150" />
                    </motion.a>
                ) : (
                    <motion.button
                        whileTap={{ scale: 0.96 }}
                        onClick={onBook}
                        data-testid="cta-book-button"
                        className="group mt-10 inline-flex items-center gap-2 rounded-control bg-brand-accent px-9 py-4 text-base font-semibold text-brand-on-accent transition-colors duration-150"
                    >
                        Schedule a Conversation
                        <ArrowUpRight className="h-5 w-5 transition-colors duration-150" />
                    </motion.button>
                )}
            </Reveal>
        </div>
    </section>
    );
};
